module.exports = __webpack_public_path__ + "media/images/icons/flags/NU-62b57e5043f6d4172183ba4303471440.svg";